import { make } from 'vuex-pathify'
import Default from './default'
import Admin from './admin'

const state = {
  menuLeft: [
    ...Default,
    ...Admin
  ]
}

const getters = make.getters(state)

const mutations = {}

const actions = {}

export default {
  namespaced: true,
  state,
  mutations,
  getters,
  actions
}
